module.exports = __webpack_public_path__ + "static/media/early-warning-signs.8cb943c7.png";